import { useStyles } from '@team-griffin/stylr';
import cssSides, { Side } from '@team-griffin/css-sides';
import { Colorway, gu2px, useTheme, cssTheme } from '@uds/theme-utils';
import { css, cx } from 'linaria';

const root = {
  default: css`
    border-top-color: rgba(${cssTheme.palette.rgb.grey06}, 0.2);
    border-top-style: solid;
    border-top-width: calc(0.5 * ${cssTheme.gu1});
  `,
  grey: css`
    border-top-color: ${cssTheme.palette.grey02};
  `,
  primary: css`
    border-top-color: ${cssTheme.palette.primary};
  `,
};
export const getClassNames = ({ isEndorsed, colorway }: { isEndorsed: boolean; colorway: Colorway }) => {
  const topBorderColor =
    [Colorway.PRIMARY, Colorway.PRIMARY_GRADIENT, Colorway.HIGHLIGHT].indexOf(colorway) > -1 ? 'grey' : 'primary';
  return {
    root: cx(root.default, isEndorsed && root[topBorderColor]),
    toggleBox: css`
      position: relative;
      // offset 3GU padding + 2GU item padding  + 1GU peak
      top: calc(${cssTheme.gu6} * -1);
      margin-bottom: calc(${cssTheme.gu6} * -1);
      box-shadow: 0 calc(-0.5 * ${cssTheme.gu1}) 0 rgba(${cssTheme.palette.rgb.grey06}, 0.2);
      &&& ${cssTheme.breakpoints.lg} {
        // offset 4GU padding + 2GU item padding  + 1GU peak
        top: calc(-7 * ${cssTheme.gu1});
        margin-bottom: calc(-7 * ${cssTheme.gu1});
      }
    `,
  };
};
export default ({ toggleHeight, hasMoreFeatures }: { toggleHeight: string | number; hasMoreFeatures: boolean }) => {
  const {
    theme: { spacing, palette },
  } = useTheme();
  return useStyles(
    {
      default: {
        list: {
          ...cssSides('margin', Side.A, 0),
          ...cssSides('padding', Side.A, 0),
          listStyle: 'none',
        },
        toggle: {
          borderWidth: 0,
          display: 'block',
          width: '100%',
          cursor: 'pointer',
          ...cssSides('padding', Side.X, 0),
          ...cssSides('padding', Side.Y, gu2px(2, spacing)),
          backgroundColor: '#fff',
          color: palette.primary,
          textAlign: 'center',
          outline: 0,
        },
        toggleIcon: {
          width: gu2px(3, spacing),
          color: palette.primary,
        },
      },
      toggleOpen: {
        list: {
          // compensate for negative margin of toggle box
          marginBottom: gu2px(4, spacing),
        },
      },
    },
    [{ toggleOpen: toggleHeight === 'auto' && hasMoreFeatures }],
  );
};
